<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Manufacturing Technology Center for Biomedical Devices</span></p>'
      //+ '<div style="margin-left : 40px; margin-bottom: 20px"><div style="font-size: 20px;"><b style="color: #033d80; "> | </b> 简介</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:65%; height:100%;">'
      + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify; line-height: 30px;"><span style="font-size: 16px">Manufacturing Technology Center for Biomedical Devices relies on the Service Platform of Medical Equipment Development. Utilizing its advanced manufacturing equipment (such as the 5-axis CNC center, metal & non-metallic 3D printers, micro-electrical discharge machines, etc.) and medical devices standard testing equipment for electrical safety and electromagnetic compatibil- ity, the center aims at providing one-stop services for research, development, and clinical translation of advanced medical devices, via assisting customized designs of mechatronic products, quick compliance examination, consultation for clinical registration, etc.</sspan></p>'
      + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify; line-height: 30px;"><span style="font-size: 16px">Supported by its professional service team, the center focuses on accelerat- ing the clinical translation of the research achivements to enhance China\'s core competitiveness in the field of medical equipment production and promote its industrial upgrade for advanced medical equipment.</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 18px; ">联系人</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; color: #033d80; ">姓名：崔祎赟</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">邮箱：cyysjtu@sjtu.edu.cn</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">电话：17740823635</span></p>'
      + '</div>'


      + '<div id="right" style="float:left ; width:35%; height:100%;">'
      + '<p style="margin-left : 80px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/swyxzzjszx4.png" style="float: center; width: 200px; " border="0" vspace="0" alt=""></p>'
      + '<p style="margin-bottom : 30px;text-align: justify; line-height: 22px;"><span style="font-size: 10px;"><b>Director: Kai Xu</b><br>' +
      'Professor, School of Mechanical Engineer- ing, Shanghai Jiao Tong Univeristy, with the Bachelor and Master degrees from Tsinghua University, as well as Ph.D. from Columbia University, USA. Awardee of the NSFC Grant for Excellent Young Scholars. Selected into the "New Century Excellent Talents in University (NCET)” program of the Ministry of Education, China, as well as the Pujiang Scholar program and the Rising Star Program of the Shanghai Metropolitan Government.</span></p>'
      + '</div>'
      + '<p style="margin-left : 20px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/biomedical_devices_en.jpg" style="float: left; width: 1200px;  margin-right: 20px;" border="0" vspace="0" alt=""></p>'

      + '<p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Yiyun Cui</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: cyysjtu@sjtu.edu.cn</span></p>'

      + '<p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service0/en/index.vue